export default {
  ar() {
    return {
      address1: 'عنوان الشارع 1',
      address2: 'عنوان الشارع 2',
      billingAndShipping: 'عنوان الشحن و الفواتير',
      city: 'المدينة',
      companyName: 'إسم الشركة',
      corporate: 'هل عملية الشراء الخاصة بك لمجموعة شركاء ؟',
      country: 'الدولة',
      disclaimer: 'إذا كان العنوان الخاص بك هو عبارة عن عنوان صندوق مكتب بريد, فيجب عليك الذهاب و استلام الحزمة الخاصة بك بنفسك من المكتب',
      firstName: 'الاسم الاول',
      lastName: 'الاسم الاخير',
      phoneNumber: 'الرقم',
      purchaseOrderNumber: 'رقم طلب الشراء',
      state: 'الولاية',
      zipCode: 'الرقم البريدي',
    }
  },
  de() {
    return {
      address1: '*Straße und Hausnummer',
      address2: 'Adresszusatz',
      billingAndShipping: 'Rechnungs- und Lieferadresse',
      city: '*Ort',
      companyName: 'Firmenname',
      corporate: 'Machen Sie Ihren Einkauf für ein Unternehmen?',
      country: '*Land',
      disclaimer: 'Wenn Ihre Rechnungsadresse eine Postfachadresse ist, muss Ihr Paket vor Ort abgeholt werden.',
      firstName: '*Vorname',
      lastName: '*Nachname',
      phoneNumber: '*Telefon',
      purchaseOrderNumber: 'Bestellnummer',
      state: '*Bundesland',
      zipCode: 'Postleitzahl',
    }
  },
  en() {
    return {
      address1: '*Street Address Line 1',
      address2: 'Street Address Line 2',
      billingAndShipping: 'Billing & Shipping Address',
      city: '*City',
      companyName: 'Company Name',
      corporate: 'Is your purchase for a corporate group?',
      country: '*Country',
      disclaimer: 'If your billing address is a P.O. Box, your package will need to be picked up on site.',
      firstName: '*First Name',
      lastName: '*Last Name',
      phoneNumber: '*Phone Number',
      purchaseOrderNumber: 'Purchase Order Number',
      state: '*State',
      zipCode: '*Zip Code / Postal Code',
    }
  },
  enGB() {
    return {
      address1: '*Street Address Line 1',
      address2: 'Street Address Line 2',
      billingAndShipping: 'Billing & Shipping Address',
      city: '*City',
      companyName: 'Company Name',
      corporate: 'Is your purchase for a corporate group?',
      country: '*Country',
      disclaimer: 'If your billing address is a P.O. Box, your package will need to be picked up on site.',
      firstName: '*First Name',
      lastName: '*Last Name',
      phoneNumber: '*Phone Number',
      purchaseOrderNumber: 'Purchase Order Number',
      state: '*State',
      zipCode: 'Zip Code / Postal Code',
    }
  },
  esMX() {
    return {
      address1: '*Dirección Línea 1',
      address2: 'Dirección Línea 2',
      billingAndShipping: 'Dirección de Facturación y Envío',
      city: '*Ciudad',
      companyName: 'Nombre de la Empresa',
      corporate: '¿Su compra es para un grupo corporativo?',
      country: '*País',
      disclaimer: 'Si su dirección de facturación es un apartado postal, tendrá que recoger su paquete en el sitio.',
      firstName: '*Nombre',
      lastName: '*Apellido',
      phoneNumber: '*Teléfono',
      purchaseOrderNumber: 'Número de Orden de Compra',
      state: '*Estado',
      zipCode: 'Código Postal',
    }
  },
  fr() {
    return {
      address1: '*Adresse de rue Ligne 1',
      address2: 'Adresse de rue Ligne 2',
      billingAndShipping: 'Adresse de facturation et de livraison',
      city: '*Ville',
      companyName: 'Nom de la société',
      corporate: 'Votre achat est-il lié à un Forfait Entreprise ?',
      country: '*Pays',
      disclaimer: 'Si votre adresse de facturation est une boîte postale, votre forfait devra être récupéré sur place.',
      firstName: '*Prénom',
      lastName: '*Nom de famille',
      phoneNumber: '*Téléphone',
      purchaseOrderNumber: 'Numéro de la commande',
      state: '*État/Province',
      zipCode: 'Code postal',
    }
  },
  it() {
    return {
      address1: '*Indirizzo',
      address2: 'Indirizzo (aggiuntivo)',
      billingAndShipping: 'Indirizzi di fatturazione e di spedizione',
      city: '*Città',
      companyName: 'Nome dell\'azienda',
      corporate: 'Il tuo acquisto è destinato a un gruppo aziendale?',
      country: '*Nazione',
      disclaimer: 'In caso il tuo indirizzo di fatturazione corrispondesse a una casella postale, il tuo pacchetto dovrà essere ritirato sul posto.',
      firstName: '*Nome',
      lastName: '*Cognome',
      phoneNumber: '*Telefono',
      purchaseOrderNumber: 'Numero dell\'ordine d\'acquisto',
      state: '*Provincia',
      zipCode: 'CAP',
    }
  },
  ja() {
    return {
      address1: '住所1',
      address2: '住所2',
      billingAndShipping: 'ご請求先および配送先住所',
      city: '都市名',
      companyName: '企業名',
      corporate: 'お客様のご注文は法人利用でのご購入ですか？',
      country: '国名',
      disclaimer: '請求先住所に私書箱をご指定の場合、チケットパッケージは現地でのお受け取りとなります。',
      firstName: '名',
      lastName: '姓',
      phoneNumber: '電話',
      purchaseOrderNumber: 'ご注文確認番号',
      state: '都道府県',
      zipCode: '郵便番号',
    }
  },
  pl() {
    return {
      address1: '*ulica i numer domu',
      address2: 'ulica i numer domu cd.',
      billingAndShipping: 'adres rozliczeniowy i do doręczeń',
      city: '*miasto',
      companyName: 'nazwa firmy',
      corporate: 'Czy to zakup dla firmy?',
      country: '*państwo',
      disclaimer: 'Jeśli w adresie rozliczeniowym podana jest skrytka pocztowa, pakiet należy odebrać osobiście na miejscu.',
      firstName: '*imię',
      lastName: '*nazwisko',
      phoneNumber: '*numer telefonu',
      purchaseOrderNumber: 'numer zamówienia',
      state: '*stan/województwo',
      zipCode: 'kod pocztowy',
    }
  },
  zhCN() {
    return {
      address1: '街道地址 1',
      address2: '街道地址 2',
      billingAndShipping: '账单及送货地址',
      city: '城市',
      companyName: '公司名称',
      corporate: '购买公司团体票吗？',
      country: '国家',
      disclaimer: 'Jeśli w adresie rozliczeniowym podana jest skrytka pocztowa, pakiet należy odebrać osobiście na miejscu.',
      firstName: '名字',
      lastName: '姓氏',
      phoneNumber: '电话号码',
      purchaseOrderNumber: '订单号',
      state: '省',
      zipCode: '邮编',
    }
  }
}
